import React from 'react';
import { useTier } from '../hooks/useTier';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

interface UpgradePromptProps {
  requiredTier: 'starter' | 'core_plus';
  featureName: string;
  children?: React.ReactNode;
}

export function UpgradePrompt({ requiredTier, featureName, children }: UpgradePromptProps) {
  const { requiresUpgrade } = useTier();

  if (!requiresUpgrade(requiredTier)) {
    return <>{children}</>;
  }

  return (
    <Card className="border-yellow-200 bg-yellow-50">
      <CardHeader>
        <CardTitle className="text-yellow-800">Upgrade Required</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-yellow-700">
          {featureName} is available on the {requiredTier} tier and above.
        </p>
        <Button onClick={() => window.location.href = '/pricing'}>
          Upgrade to {requiredTier}
        </Button>
      </CardContent>
    </Card>
  );
}
